import React from 'react'
import gql from 'graphql-tag'
import { Mutation, MutationFn } from 'react-apollo'

export const toggleOrganizationRestrictedEditRoleMutation = gql`
  mutation ToggleOrganizationRestrictedEditRole(
    $organizationID: ID!
    $enabled: Boolean!
  ) {
    toggleOrganizationRestrictedEditRole(
      input: { organizationID: $organizationID, enabled: $enabled }
    ) {
      _placeholder
    }
  }
`

export interface ToggleOrganizationRestrictedEditRoleArgs {
  readonly organizationID: string
  readonly enabled: boolean
}

export function ToggleOrganizationRestrictedEditRoleMutation({
  children
}: {
  readonly children: (
    toggleOrganizationRestrictedEditRole: MutationFn<
      {},
      ToggleOrganizationRestrictedEditRoleArgs
    >
  ) => React.ReactNode
}) {
  return (
    <Mutation<{}, ToggleOrganizationRestrictedEditRoleArgs>
      mutation={toggleOrganizationRestrictedEditRoleMutation}
    >
      {(toggleOrganizationRestrictedEditRole) => {
        return children(toggleOrganizationRestrictedEditRole)
      }}
    </Mutation>
  )
}
